import React from "react";

const PrivacyPage: React.FC = () => {
  return (
    <>
      <div style={{ paddingLeft: "20px", paddingRight: "20px" }}>
        <h1>CampusPocket プライバシーポリシー</h1>

        <p>
          当アプリは、CampusPocket (以下、「当アプリ」といいます)
          の利用に際して、個人情報の取り扱いについて以下のプライバシーポリシーを定めています。
        </p>

        <h2>1. 収集する個人情報</h2>
        <p>
          1.1
          当アプリでは、利用者がアプリをダウンロードした際に提供される以下の情報を収集することがあります。
        </p>
        <ul>
          <li>ユーザーが登録したニックネーム</li>
          <li>連絡先情報（メールアドレス、電話番号など）</li>
          <li>その他、ユーザーが当アプリを利用するにあたり提供する情報</li>
        </ul>

        <h2>2. 取得した個人情報の利用目的</h2>
        <p>2.1 当アプリは、収集した個人情報を以下の目的で利用します。</p>
        <ul>
          <li>ユーザーのアカウント作成</li>
          <li>お問い合わせへの対応</li>
          <li>サービスの提供および運営管理</li>
          <li>アプリの改善や新しいサービスの開発</li>
          <li>利用規約に違反する行為の防止および当アプリの適切な利用確保</li>
        </ul>

        <h2>3. 個人情報の共有と第三者への提供</h2>
        <p>
          3.1
          当アプリは、法令に基づく場合またはユーザーの同意がある場合を除き、収集した個人情報を第三者に提供しません。
        </p>
        <p>
          3.2 ただし、以下の場合には個人情報の提供が行われることがあります。
        </p>
        <ul>
          <li>法令に基づく場合</li>
          <li>ユーザーの同意がある場合</li>
          <li>裁判所、警察、その他の公的機関からの要請があった場合</li>
        </ul>

        <h2>4. 個人情報の管理</h2>
        <p>4.1 当アプリは、個人情報の適切な管理を行います。</p>
        <p>
          4.2
          個人情報へのアクセス権限は、必要最小限に制限され、情報への不正アクセス、紛失、改ざん、漏洩などを防止するための措置を講じます。
        </p>

        <h2>5. Cookieの利用</h2>
        <p>5.1 当アプリは、一部のページでCookieを使用しています。</p>
        <p>
          5.2
          Cookieは個人情報を特定するものではなく、利用者のブラウザに保存される情報であり、アプリの利用状況を把握するために使用されます。
        </p>
        <p>
          5.3
          利用者は、ブラウザの設定を変更することでCookieの受け入れを拒否することができますが、その場合、アプリの一部機能が制限される可能性があります。
        </p>

        <h2>8. プライバシーポリシーの変更</h2>
        <p>
          8.1
          当アプリは、必要に応じてプライバシーポリシーを変更することがあります。
        </p>
        <p>
          8.2
          変更後のプライバシーポリシーは、当アプリに掲示された時点で効力を生じるものとします。
        </p>

        <h2>9. お問い合わせ先</h2>
        <p>
          9.1
          当アプリの個人情報の取り扱いに関するお問い合わせは、以下の連絡先までご連絡ください。
        </p>
        <p>メールアドレス: support@campus-pocket.com</p>

        <p>最終更新日: 2023年8月6日</p>
      </div>
    </>
  );
};

export default PrivacyPage;
